import { render, staticRenderFns } from "./PS-metadata-widget.vue?vue&type=template&id=101c5259"
import script from "./PS-metadata-widget.vue?vue&type=script&lang=js"
export * from "./PS-metadata-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports